export default theme => ({
    quote: {
        display: 'block',
        position: 'relative',
        marginBottom: 36,
    },
})